module.exports = __webpack_public_path__ + "fonts/fontawesome.674f50d2.eot";